import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {Video} from '../atoms/Video';
import {Picture} from '../atoms/Picture';
import {BrokenImageIcon} from '../svg/BrokenImageIcon';

export const EventThumbnail = (props) => {
  const {eventId, alt = 'template design', loading = 'eager', className = null} = props;

  const [hasMediaError, setHasMediaError] = useState(false);
  const [mediaType, setMediaType] = useState(null);
  const thumbnailWidth = 100;
  const thumbnailHeight = 132;

  const mediaUrl = `/event/${eventId}/og-image`;

  useEffect(() => {
    const img = new Image();

    img.onload = () => {
      setMediaType('image');
    };

    img.onerror = () => {
      setMediaType('video');
    };

    img.src = mediaUrl;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [mediaUrl]);

  if (hasMediaError) {
    return <BrokenImageIcon />;
  }
  if (!mediaType) {
    return <span className="evt-spinner inline" />;
  }
  return mediaType === 'image' ? (
    <Picture
      srcSet={mediaUrl}
      alt={alt}
      loading={loading}
      className={className}
      width={thumbnailWidth}
      height={thumbnailHeight}
      onError={() => setHasMediaError(true)}
    />
  ) : (
    <Video
      src={mediaUrl}
      className={className}
      mimeType="video/mp4"
      width={thumbnailWidth}
      height={thumbnailHeight}
      onError={() => setHasMediaError(true)}
    />
  );
};
EventThumbnail.propTypes = {
  loading: PropTypes.oneOf(['lazy', 'eager']),
  eventId: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
};
